






















































































































































































































































































































































































































































































































import { authPermissions } from '@/constants'
import { calendarService } from '@/services'
import { CalendarAvailablePage, CalendarChangeEvent, CalendarEvent, CalendarEventMetadata, CalendarEvents, CalendarForm } from '@/types/CalendarType'
import { getAxiosErrors } from '@/utils'
import Vue from 'vue'

function generateInitialState() {
    return {
        errors: {} as Record<string, string>,
        success: false as boolean,
        loading: false as boolean
    }
}


function generateForm(): CalendarForm {

    return {
        payload: {
            id: '',
            pageName: '',
            dataSource: '',
            dateField: '',
            titleField: '',
            color: '',
        },
        state: generateInitialState(),
        selectedDataSourceAndPage: null
    }
}

export default Vue.extend({
    name: 'Calendar',
    async mounted() {
        await this.getAvailableSources()
    },
    data() {
        return {
            calendarLoading: true,
            formDialog: false,
            focus: '',
            calendarView: 'month',
            pages: [] as CalendarAvailablePage[],
            form: generateForm(),
            calendarEventFields: {} as CalendarEvents,
            selectedOpen: false,
            selectedCalendarEvent: {} as CalendarEvent,
            selectedCalendarEventElement: null as any,
            deleteForm: {
                state: generateInitialState(),
                payload: {} as CalendarEventMetadata
            },
            deleteFormDialog: false,
            // Calendar date picker
            dates: [] as string[],
            datePickerMenu: false,
            // End of Calendar Date picker
            calendarViews: {
                month: 'month',
                week: 'week',
                fourdays: '4day'
            },
            dateOptions:  {
                month: 'long', 
                day: 'numeric', 
                year: 'numeric' 
            } as any,
            weekday: [0, 1, 2, 3, 4, 5, 6]
        }
    },
    computed: {
        calendarType(): string {
            if (this.calendarView === this.calendarViews.month) return this.calendarViews.month
            if (this.calendarView === this.calendarViews.week) return this.calendarViews.week

            if (this.calendarView === this.calendarViews.fourdays) return this.calendarViews.fourdays
            return 'month'
        },
        title() {
            return this.$refs.calendar
                ? (this.$refs.calendar as any).title
                : ''
        },
        calendarEvents(): CalendarEvent[] {
            const events = [] as CalendarEvent[]
            const metadata = this.calendarEventFields?.metadata || {}
            
            for(let i = 0; i < this.calendarEventFields?.records?.length; i++){
                const field = this.calendarEventFields.records[i]
                if(metadata[field.metadataId]?.enabled){
                    // Change to 
                    events.push({
                        name: field.title,
                        start:new Date(field.date),
                        end: new Date(field.date),
                        color: metadata[field.metadataId]?.color,
                        dateFieldAlias: metadata[field.metadataId]?.dateField,
                        titleFieldAlias: metadata[field.metadataId]?.titleField,
                        titleFieldValue: field.title,
                        dataSource: metadata[field.metadataId]?.dataSource,
                        pageAlias: metadata[field.metadataId]?.pageAlias
                    })

                }
            }

            return events
        },
        calendarEventsMetadata(): CalendarEventMetadata[] {
            return Object.values(this.calendarEventFields?.metadata || [])
        },
        availableDateFields(): string[] {
            const selected = this.form.selectedDataSourceAndPage
            if (!selected) return []
            return selected.dateFields
        },
        availableTitleFields(): string[] {
            const selected = this.form.selectedDataSourceAndPage
            if (!selected) return []
            return selected.titleFields
        },
        startDate(): string{
            return this.dates[0] && new Date(this.dates[0]).toLocaleDateString(undefined, this.dateOptions)

        },
        endDate(): string {
            return this.dates[1] &&  new Date(this.dates[1]).toLocaleDateString(undefined, this.dateOptions)
        },
        monthPicker(): string {
            return this.focus ? this.focus.slice(0, 7) : ''
        },
        userHasEditPermission(): boolean {
            return this.$store.getters.user.permissions[authPermissions.canManageCalendar]
        }
    },
    methods: {
        formatTeamsDateTime(start: string | Date, end?: string | Date) {
            if (!start) return ''

            const startDate = new Date(start)
    
            // Get the user's browser locale (e.g., 'en-GB', 'en-PH', 'fr-FR')
            // Using undefined defaults to the browser's current locale
            const userLocale = undefined 

            const dateOptions = { 
                weekday: 'short', 
                month: 'numeric', 
                day: 'numeric', 
                year: 'numeric' 
            } as any
    
            const timeOptions = { 
                hour: 'numeric', 
                minute: '2-digit', 
                hour12: true // Most users prefer AM/PM for calendar events
            } as any

            // Format the date part
            const datePart = startDate.toLocaleDateString(userLocale, dateOptions)
    
            // Logic to handle different locale punctuation (removing extra commas)
            const cleanDate = datePart.replace(/,/g, '')

            // Format the time parts
            const startTimePart = startDate.toLocaleTimeString(userLocale, timeOptions)

            if (end && end !== start) {
                const endDate = new Date(end)
                const endTimePart = endDate.toLocaleTimeString(userLocale, timeOptions)
                return `${cleanDate} ${startTimePart} - ${endTimePart}`
            }

            return `${cleanDate} ${startTimePart}`
        },
        async getAvailableSources() {
            // allowable inputs
            try {
                this.pages = await calendarService.getAvailableSources()
            } catch(e) {
                console.error('Error fetching calendar sources', e)
            }
            

        },  
        async getCalendarEventFields(start: string, end: string) {
            this.calendarLoading = true
            this.calendarEventFields =  await calendarService.getCalendarEvents(start, end)
            this.calendarLoading = false
            
        },
        eventColor(event: any) {
            return event.color
        },
        onAddField() {
            this.form = generateForm()
            this.formDialog = true
        },
        async onSaveField() {
            try {
                this.form.state = generateInitialState()
                this.form.state.loading = true
                await calendarService.upsertCalendarField({
                    id: this.form.payload.id,
                    dataSource: this.form.selectedDataSourceAndPage?.dataSource || '',
                    pageName: this.form.selectedDataSourceAndPage?.pageName || '',
                    dateField: this.form.payload.dateField,
                    titleField: this.form.payload.titleField,
                    color: this.form.payload.color
                })

                this.form.state.success = true
                await this.getCalendarEventFields(this.dates[0], this.dates[1])
            } catch(e) {
                this.form.state.errors = getAxiosErrors(e)
            } finally {
                this.form.state.loading = false
            }
        },
        onEditField(field: CalendarEventMetadata) {
            this.form = generateForm()
            this.form.selectedDataSourceAndPage = this.pages.find(p => p.dataSource === field.dataSource && p.pageName === field.pageName) || null
            
            this.form.payload = {
                id: field.id,
                dataSource: field.dataSource,
                pageName: field.pageName,
                dateField: field.dateField,
                titleField: field.titleField,
                color: field.color
            }
            this.formDialog = true
        },
        onDeleteField(field: CalendarEventMetadata) {
            this.deleteForm.state = generateInitialState()
            this.deleteForm.payload = field
            this.deleteFormDialog = true
        },
        async onDeleteConfirm() {
            try {
                this.deleteForm.state = generateInitialState()
                this.deleteForm.state.loading = true
                await calendarService.deleteCalendarField(this.deleteForm.payload)

                this.deleteForm.state.success = true
                await this.getCalendarEventFields(this.dates[0], this.dates[1])
            } catch(e) {
                this.deleteForm.state.errors = getAxiosErrors(e)
            } finally {
                this.deleteForm.state.loading = false
            }
        },
        showEvent({ nativeEvent, event } : any) {
            const open = () => {
                this.selectedCalendarEvent = event
                this.selectedCalendarEventElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        prev() {
            const calendar = this.$refs.calendar as any
            calendar.prev()
        },
        next() {
            const calendar = this.$refs.calendar as any
            calendar.next()
        },
        goToday() {
            this.focus = ''
        },
        generateDataSourceAndPage(availablePage: CalendarAvailablePage) {
            return `${availablePage.dataSource} - ${availablePage.pageAlias}`
        },
        async onCalendarChange(event: CalendarChangeEvent) {
            // Placeholder for any calendar change events that may require a nav bar update in the future
            const start = new Date(event.start.date)
            const end = new Date(event.end.date)

            this.dates = [start.toISOString().split('T')[0], end.toISOString().split('T')[0]]
            await this.getCalendarEventFields(this.dates[0], this.dates[1])
        },
        handleDateInput(val: any) {
            if (val.length === 1) {
                const startDate = new Date(val[0])

                // Close menu after selection
                setTimeout(() => { this.datePickerMenu = false }, 300)
                this.focus = startDate.toISOString().split('T')[0]
            }
        },
        onMonthPick(date: string) {
            this.focus = `${date}-01`
            this.datePickerMenu = false
        }
    }
})
